import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';

interface IFullScreenCallViewPanelPresenter {
  ongoingCall: Call | null;
  callTitle: string;
  canShowPermissionsRequestsButton: boolean;
  isRecording: boolean;
  isUnauthorizedCall: boolean;
}

export const useFullScreenCallViewPanelPresenter = (): IFullScreenCallViewPanelPresenter => {
  const context = useCallContext();

  const presenter = useLocalObservable<IFullScreenCallViewPanelPresenter>(() => ({
    get ongoingCall(): Call | null {
      return context.call;
    },

    get callTitle(): string {
      return presenter.ongoingCall?.avatar?.title || '';
    },

    get canShowPermissionsRequestsButton(): boolean {
      if (!presenter.ongoingCall) {
        return false;
      }

      return (
        presenter.ongoingCall.isMeInitiatorOwnerOrAdmin &&
        !presenter.ongoingCall.isPermissionsRequestsEmpty
      );
    },

    get isRecording(): boolean {
      return !!presenter.ongoingCall?.isRecording;
    },

    get isUnauthorizedCall(): boolean {
      return !!presenter.ongoingCall?.isUnauthorizedCall;
    },
  }));

  return presenter;
};
